"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDashboardModalVisibleState = void 0;
const react_1 = __importDefault(require("react"));
const recoil_1 = require("recoil");
const react_i18next_1 = require("react-i18next");
const dashboard_1 = require("../../../server/models/dashboard");
const folder_1 = require("../../../server/models/folder");
const SaveInFolderModal_1 = __importDefault(require("./SaveInFolderModal"));
const react_router_dom_1 = require("react-router-dom");
const EmbedRoute_1 = __importDefault(require("../../../routes/EmbedRoute"));
const RedirectTo_1 = __importDefault(require("../../../utilities/RedirectTo"));
exports.createDashboardModalVisibleState = (0, recoil_1.atom)({
    key: 'createDashboardModalVisibleState',
    default: false,
});
const CreateDashboardModal = ({ defaultFolderId, t, }) => {
    const [visible, setVisible] = (0, recoil_1.useRecoilState)(exports.createDashboardModalVisibleState);
    const history = (0, react_router_dom_1.useHistory)();
    const successCallback = (dashboard) => {
        return (0, RedirectTo_1.default)({
            history,
            path: EmbedRoute_1.default.dashboardQueryString(dashboard.folder.id, dashboard.id),
        });
    };
    const saveInFolderModalProps = {
        defaultFolderId: defaultFolderId,
        formSubmitCallback: async (title, folderId) => await (0, dashboard_1.createDashboard)(title, String(folderId)),
        successCallback: successCallback,
        successMessage: t('dashboardCreateSuccess'),
        failureMessage: t('dashboardCreateFail'),
        errorMessage: t('dashboardCreateError'),
        titleName: 'createDashboardTitle',
        titleValidationCallback: async (title, folderId) => await (0, folder_1.verifyDashboardNameUniqueIn)(title, folderId.toString()),
        notificationMessage: t('dashboardCreateNotify'),
        notificationMessageWaitTime: 1000,
        notificationMessageType: 'info',
        placeholder: t('dashboardCreatePlaceholder'),
        duplicateErrorMessage: t('dashboardCreateDuplicate'),
        headerText: t('dashboardCreateHeader'),
        primaryButtonText: t('dashboardCreateButton'),
        visible: visible,
        setVisible: (isVisible) => setVisible(isVisible),
        t: t,
    };
    return react_1.default.createElement(SaveInFolderModal_1.default, { ...saveInFolderModalProps });
};
exports.default = (0, react_i18next_1.withTranslation)('ModalWindow')(CreateDashboardModal);
